import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { OnlineOrder, Customer, Company } from '../../../../shared/models';

import { OnlineOrdersService } from '../../../../shared/services/online-orders.service';
import { CustomerService } from '../../../../shared/services/customer.service';
import { ApiService } from '../../../../shared/services/api.service';

@Component({
    selector: 'app-online-order-details',
    templateUrl: './online-order-details.component.html',
    styleUrls: ['./online-order-details.component.scss'],
    standalone: false
})
export class OnlineOrderDetailsComponent implements OnInit {
	customer: Customer;
	onlineOrder: OnlineOrder;
  whatsMsg: string;

  constructor(private ooServ: OnlineOrdersService,
  	private customerServ: CustomerService,
  	private api: ApiService,
  	private router: Router,
  	private route: ActivatedRoute) { }

  ngOnInit(): void {
  	this.customer = this.customerServ.getCustomer();

  	let oo: OnlineOrder = this.ooServ.getSelected();
  	OnlineOrder.setAdditionalData(oo);

  	this.onlineOrder = oo;
  	this._loadOnlineOrder();

    this.whatsMsg = `Olá meu nome é ${this.customer.name}, sobre o meu pedido feito pelo site:`;
  }

  goBack() {
  	this.ooServ.clearSelected();
  	this.router.navigate(['..'], {relativeTo: this.route});
  }

  private _loadOnlineOrder() {
  	this.route.paramMap.subscribe(params => {
  		let id = params.get("online_order_id");
  		this.api.show('online_orders', id, {
  			token: this.customer.token
  		}).subscribe(
  			res => {
  				OnlineOrder.setAdditionalData(res.online_order);
  				this.onlineOrder = res.online_order;
  			},
  			err => {
  				console.error(err);
  			}
  		);
  	});
  }
}
